<div class="mt-4">
  <!-- Add Job Button -->
  <div class="d-flex align-items-center justify-content-between">
    <button class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#jobModal" (click)="resetForm()">
      <i class="fas fa-plus"></i> Stelle hinzufügen
    </button>
    <select class="form-select w-auto mb-3" [(ngModel)]="selectedCategory" (change)="filterByCategory()">
      <option value="">Alle Kategorien</option>
      <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
    </select>
  </div>

  <!-- Jobs Table -->
  <div class="table-responsive always-scroll">
    <table class="table table-striped align-middle dashboard-table">
      <thead>
        <tr>
          <th>Titel</th>
          <th>Text</th>
          <th>Bild</th>
          <th>Kategorie</th>
          <th>Zusätzliche Informationen</th>
          <th>Häufige Fragen</th>
          <th>Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of jobs" class="job-row">
          <td class="image-col">
            <img *ngIf="job.image" [src]="job.image" loading="lazy" alt="Vorschau" class="img-thumbnail" style="width: 60px; height: 60px;">
          </td>
          <td class="title-col">
            <span class="text-lg-wrap text-lg-break">{{ job.title }}</span>
          </td>
          <td class="text-col">
            <span class="text-lg-wrap text-lg-break" [title]="job.text">{{ job.text | slice:0:50 }}{{ job.text.length > 50 ? '...' : '' }}</span>
          </td>
          <td class="category-col">
            {{ job.category }}
          </td>
          <td class="info-col">
            <span class="text-lg-wrap text-lg-break">{{ job.additionalInfo | slice:0:50 }}</span>
          </td>
          <td class="faqs-col">
            {{ job.faqs?.length }} Fragen
          </td>
          <td class="actions-col">
            <button class="btn btn-warning btn-sm me-2" (click)="editJob(job)">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-danger btn-sm me-2" (click)="deleteJob(job.id!)">
              <i class="fas fa-trash"></i>
            </button>
            <button class="btn btn-info btn-sm" [routerLink]="['/job-details', job.id]">
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="jobs.length === 0 && showSpinner==false" style="text-align: center;">
          <td colspan="7" class="text-muted">Keine Stellen verfügbar</td>
        </tr>
        <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="7">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Lädt...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Job Modal -->
<div class="modal fade" id="jobModal" tabindex="-1" aria-labelledby="jobModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <form #jobForm="ngForm" (ngSubmit)="saveJob(jobForm)">
        <div class="modal-header">
          <h5 class="modal-title" id="jobModalLabel">{{ editMode ? 'Stelle bearbeiten' : 'Stelle hinzufügen' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- Title -->
          <div class="mb-3">
            <label>Titel <span class="text-danger">*</span></label>
            <input type="text" 
                   class="form-control"
                   name="title" 
                   [(ngModel)]="currentJob.title" 
                   #title="ngModel" 
                   required
                   minlength="3">
            <div *ngIf="title.invalid && title.touched" class="text-danger small">
              <div *ngIf="title.errors?.['required']">Titel ist erforderlich</div>
              <div *ngIf="title.errors?.['minlength']">Titel muss mindestens 3 Zeichen lang sein</div>
            </div>
          </div>

          <!-- Category -->
          <div class="mb-3">
            <label>Kategorie <span class="text-danger">*</span></label>
            <select class="form-select"
                    name="category"
                    [(ngModel)]="currentJob.category"
                    #category="ngModel"
                    required>
              <option value="">Kategorie auswählen</option>
              <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
              <option value="Other">Andere</option>
            </select>
            <div *ngIf="category.invalid && category.touched" class="text-danger small">
              Kategorie ist erforderlich
            </div>
          </div>

          <!-- Show input only when 'Other' is selected -->
          <div class="mb-3" *ngIf="currentJob.category === 'Other'">
            <label>Kategorie spezifizieren <span class="text-danger">*</span></label>
            <input type="text"
                   class="form-control"
                   [(ngModel)]="customCatigory"
                   #customCategoryModel="ngModel"
                   name="customCatigory"
                   required>
            <div *ngIf="customCategoryModel.invalid && customCategoryModel.touched" class="text-danger small">
              Benutzerdefinierte Kategorie ist erforderlich, wenn 'Andere' ausgewählt ist
            </div>
          </div>

          <!-- Text -->
          <div class="mb-3">
            <label>Text <span class="text-danger">*</span></label>
            <textarea class="form-control"
                      name="text" 
                      [(ngModel)]="currentJob.text" 
                      #text="ngModel" 
                      required
                      rows="5"
                      minlength="5"></textarea>
            <div *ngIf="text.invalid && text.touched" class="text-danger small">
              <div *ngIf="text.errors?.['required']">Text ist erforderlich</div>
              <div *ngIf="text.errors?.['minlength']">Text muss mindestens 5 Zeichen lang sein</div>
            </div>
          </div>

          <!-- Additional Info -->
          <div class="mb-3">
            <label>Zusätzliche Informationen</label>
            <input type="text" 
                   class="form-control"
                   name="additionalInfo" 
                   [(ngModel)]="currentJob.additionalInfo">
          </div>

          <!-- Image Upload -->
          <div class="mb-3">
            <label>Bild</label>
            <input type="file" class="form-control" (change)="onFileSelected($event)">
            <div *ngIf="currentJob.image" class="mt-2">
              <img [src]="currentJob.image" loading="lazy" alt="Vorschau" class="img-thumbnail" style="width: 100px; height: 100px;">
            </div>
          </div>

          <!-- FAQs -->
          <div class="mb-3">
            <label>Häufige Fragen</label>
            <div *ngFor="let faq of currentJob.faqs; let i = index" class="mb-3 border p-3 rounded">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6>Frage {{ i + 1 }}</h6>
                <button type="button" class="btn btn-danger btn-sm" (click)="removeFaq(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div class="mb-2">
                <label>Frage <span class="text-danger">*</span></label>
                <input type="text" 
                       class="form-control"
                       [name]="'faqQuestion' + i"
                       [(ngModel)]="faq.question"
                       #faqQuestion="ngModel"
                       required>
                <div *ngIf="faqQuestion.invalid && faqQuestion.touched" class="text-danger small">
                  Frage ist erforderlich
                </div>
              </div>
              <div>
                <label>Antwort <span class="text-danger">*</span></label>
                <textarea class="form-control"
                          [name]="'faqAnswer' + i"
                          [(ngModel)]="faq.answer"
                          #faqAnswer="ngModel"
                          required></textarea>
                <div *ngIf="faqAnswer.invalid && faqAnswer.touched" class="text-danger small">
                  Antwort ist erforderlich
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-outline-primary" (click)="addFaq()">
              <i class="fas fa-plus"></i> Frage hinzufügen
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
          <button type="submit" class="btn btn-success" [disabled]="jobForm.invalid" data-bs-dismiss="modal">
            <i class="fas fa-save"></i> {{ editMode ? 'Aktualisieren' : 'Speichern' }}
          </button>
        </div>
      </form>
    </div>
  </div> 
</div>